import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-vom-dienst-befreien';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenBenutzerVomDienstBefreienEffects {

    BenutzerVomDienstBefreien$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_VOM_DIENST_BEFREIEN),
        mergeMap((x: ac.PostBenutzerVomDienstBefreienAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerVomDienstBefreien(x.benutzerVomDienstBefreienRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerVomDienstBefreienErfolgreichAction(result, x.benutzerVomDienstBefreienRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerVomDienstBefreienFehlerAction(error, x.benutzerVomDienstBefreienRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
